/**
 * Shows errors at the respective position.
 * Example: If passed errors array contains a 'name' key, the error message will be placed below the Name field in the form
 * @param {Element} form
 * @param {Array} errors 
 */
export function HandleFormErrors(form, errors) {
	Object.keys(errors).forEach((key) => {
		let error = errors[key];
		let input = form.querySelector('input[name="' + key + '"]');

		if (!input)
			input = form.querySelector('input[name="' + key + '[]"]');

		if (!input)
			return;

		let formField = input.closest('.form-field');
		if (!formField)
			return;

		let inputError = formField.querySelector('.input-error');
		if (!inputError)
			return;

		inputError.innerHTML = error;
		inputError.classList.remove("hidden");
	});
}

/**
 * Hides all error fields in the passed form by assigning the css class 'hidden' to each of them
 * @param {Element} form 
 */
export function HideErrorFields(form) {
	const errorFields = form.querySelectorAll('.input-error');
	errorFields.forEach((errorField) => {
		errorField.classList.add('hidden');
	});
}

/**
 * Searches for all inputs/textareas in the passed forms and clears the values
 * @param {Element} form 
 */
export function ClearAllFields(form) {
	const formFields = form.querySelectorAll('input, textarea');

	formFields.forEach((field) => {

		if (field.type == 'radio' | field.type == 'checkbox')
			field.checked = false;
		else if (field.type !== 'hidden')
			field.value = null;
	});

	form.querySelectorAll('.file-name').forEach((span) => {
		span.innerHTML = '';
	});
}